import CalendarMarkIcon from "~/components/icons/CalendarMarkIcon";
import SectionHeading from "~/components/SectionHeading";
import GiftIcon from "~/components/icons/GiftIcon";
import {useState} from "react";
import GiftCertificatePanel from "~/components/giftcertificates/GiftCertificatePanel";
import {formatCurrency} from "~/lib/CurrencyHelpers";
import {ChevronRightIcon} from "@heroicons/react/24/outline/index.js";

const GiftCertificatesList = ({giftCertificates, className, refetch}) => {
    const [selectedGiftCertificate, setSelectedGiftCertificate] = useState(null)
    return (
        <div className={className}>
            <SectionHeading icon={<GiftIcon />} name="Gift Certificates" />
            <div className="mt-2 panel pl-4 divide-y">
                {giftCertificates.map((gc) => (
                    <div
                        className="cursor-pointer py-3 mr-4 flex items-center justify-between"
                        onClick={() => setSelectedGiftCertificate(gc)}
                        key={gc.id}
                    >
                        <div>
                            <div>{gc.recipient?.name}</div>
                            <div className="text-gray-500">{formatCurrency(gc.value)}</div>
                        </div>
                        <ChevronRightIcon className="w-5 h-5 text-gray-400" />
                    </div>
                ))}
            </div>

            <GiftCertificatePanel
                isOpen={!!selectedGiftCertificate}
                onClose={() => setSelectedGiftCertificate(null)}
                id={selectedGiftCertificate?.id}
                refetch={refetch}
            />
        </div>
    )
}

export default GiftCertificatesList;
